import { echartSetOption } from '../echarts-utils';

const barWaterFallChartInit = () => {
  const { getColor, getData } = window.phoenix.utils;
  const $chartEl = document.querySelector(
    '.echart-bar-waterfall-chart-example'
  );
  const days = [
    '2021-06-05',
    '2021-06-06',
    '2021-06-07',
    '2021-06-08',
    '2021-06-09',
    '2021-06-10',
    '2021-06-11',
    '2021-06-12',
    '2021-06-13',
    '2021-06-14',
    '2021-06-15'
  ];

  if ($chartEl) {
    const userOptions = getData($chartEl, 'echarts');
    const chart = window.echarts.init($chartEl);
    const getDefaultOptions = () => ({
      legend: {
        data: ['Expenditure', 'Income'],
        textStyle: {
          color: getColor('text-color-body-quaternary')
        },
        top: 0,
        itemGap: 10
      },
      tooltip: {
        trigger: 'axis',
        padding: [7, 10],
        backgroundColor: getColor('background-color-body-highlight'),
        borderColor: getColor('border-color-base'),
        textStyle: { color: getColor('text-color-light-emphasis') },
        borderWidth: 1,
        /* eslint-disable prefer-destructuring */
        formatter: params => {
          let tar;
          if (params[1].value !== '-') {
            tar = params[1];
          } else {
            tar = params[2];
          }
          return `${window.dayjs(tar.name).format('MMM DD')}<br/>${
            tar.seriesName
          } : ${tar.value}`;
        },
        transitionDuration: 0,
        axisPointer: {
          type: 'shadow'
        }
      },
      xAxis: {
        type: 'category',
        data: days,
        axisLine: {
          lineStyle: {
            color: getColor('background-color-body-tertiary'),
            type: 'solid'
          }
        },
        axisTick: { show: false },
        axisLabel: {
          color: getColor('text-color-body-quaternary'),
          formatter: value => window.dayjs(value).format('MMM DD'),
          margin: 15
        },
        splitLine: {
          show: false
        }
      },
      yAxis: {
        type: 'value',
        boundaryGap: true,
        axisLabel: {
          show: true,
          color: getColor('text-color-body-quaternary'),
          margin: 15
        },
        splitLine: {
          show: true,
          lineStyle: {
            color: getColor('background-color-body-secondary')
          }
        },
        axisTick: { show: false },
        axisLine: { show: false },
        min: 600
      },
      series: [
        {
          name: 'Assist',
          type: 'bar',
          stack: 'Total',
          itemStyle: {
            barBorderColor: 'transparent',
            color: 'transparent'
          },
          emphasis: {
            itemStyle: {
              barBorderColor: 'transparent',
              color: 'transparent'
            }
          },
          data: [0, 900, 1245, 1530, 1376, 1376, 1511, 1689, 1856, 1495, 1292]
        },
        {
          name: 'Income',
          type: 'bar',
          stack: 'Total',
          label: {
            show: true,
            position: 'top',
            color: getColor('text-color-body-quaternary')
          },
          data: [1000, 400, 350, '-', '-', 320, 180, 190, '-', '-', '-'],
          itemStyle: {
            color: getColor('color-primary'),
            barBorderRadius: [3, 3, 0, 0]
          }
        },
        {
          name: 'Expenditure',
          type: 'bar',
          stack: 'Total',
          label: {
            show: true,
            position: 'bottom',
            color: getColor('text-color-body-quaternary')
          },
          data: ['-', '-', '-', 100, 140, '-', '-', '-', 120, 345, 190],
          itemStyle: {
            color: getColor('color-success'),
            barBorderRadius: [3, 3, 0, 0]
          }
        }
      ],
      grid: { right: '3%', left: '10%', bottom: '10%', top: '10%' }
    });
    echartSetOption(chart, userOptions, getDefaultOptions);
  }
};

export default barWaterFallChartInit;
